import { ReactElement } from 'react'
import { cn } from '@/lib/utils.ts'
import { ButtonSizeT, buttonVariants, ButtonVariantT } from '@/components/ui/Button.tsx'
import { X } from 'lucide-react'

export default function TriggerWithCloseBtnWrapper({
  trigger,
  onClick,
  variant,
  size,
  className,
}: {
  trigger: ReactElement
  onClick?: () => void
  variant?: ButtonVariantT
  size?: ButtonSizeT
  className?: string
}) {
  return (
    <div
      className={cn(
        `cursor-pointer`,
        buttonVariants({
          variant: variant ?? 'outline',
          size: size ?? 'sm',
          className,
        }),
      )}
    >
      {trigger}
      <X className={`size-4 duration-200 hover:stroke-destructive`} onClick={onClick} />
    </div>
  )
}
